import React from "react";
// Resources
import logoImage from "assets/img/Auth/logo.png";
import styles from "./LogoImage.module.scss";

export const LogoImage: React.FC = () => <img className={styles.logo} src={logoImage} alt="Logo" />;
